var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manager-salary"},[_c('IxRes',[_vm._v("dlgCert.social.salary.hints.noSalaryInfoForManagers")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }